export default (theme) => ({
  root: {},
  page: {
    minHeight: 'calc(100 * var(--vh))',
    [theme.mq.md]: {
      minHeight: 'calc(var(--vh-fixed) * 100)',
    },
  },
  header: {
    paddingTop: 190,
    paddingBottom: 60,
    paddingLeft: theme.padding[1],
    paddingRight: theme.padding[1],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    '& .pretit': {
      marginBottom: 15,
    },
    '& h1': {
      textTransform: 'uppercase',
      fontWeight: 300,
      margin: 0,
      color: theme.colors[2],
      '& span': {
        color: theme.colors[0],
      },
    },

    [theme.mediaInverse.md]: {
      paddingTop: 120,
      paddingBottom: 20,
      paddingLeft: theme.paddingMobile[1],
      paddingRight: theme.paddingMobile[1],
    },
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
  },
  filter: {
    '& button': {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      color: theme.colors[6],
      fontSize: 12,
      letterSpacing: '1.3px',
      textTransform: 'uppercase',
      fontFamily: theme.fonts[0],
      fontWeight: 400,
      transition: `all 0.3s ${theme.easings.garret}`,
      '& svg': {
        width: 16,
        height: 16,
        fill: theme.colors[6],
        transition: `all 0.3s ${theme.easings.garret}`,
      },
      '& .swap-text': {
        marginLeft: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        height: 17,
        overflow: 'hidden',
        '& span': {
          whiteSpace: 'nowrap',
          transition: `transform 1s ${theme.easings.garret}`,
        },
      },
      '@media (hover: hover)': {
        '&:hover': {
          color: theme.colors[2],
          '& svg': {
            fill: theme.colors[2],
          },
        },
      },
    },

    [theme.mediaInverse.sm]: {
      display: 'none',
    },
  },
  filterActive: {
    '& button': {
      '& .swap-text': {
        '& span': {
          transform: 'translateY(-100%)',
        },
      },
    },
  },
  grid: {
    paddingBottom: 240,
    paddingLeft: theme.padding[1],
    paddingRight: theme.padding[1],
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: `calc(-${theme.padding[1]} / 2)`,
    marginRight: `calc(-${theme.padding[1]} / 2)`,
    '@supports (display: grid)': {
      marginLeft: 0,
      marginRight: 0,
      display: 'grid',
      gridGap: 60,
      gridTemplateColumns: 'repeat(3,1fr)',
      justifyContent: 'center',
      alignContent: 'end',
      gridAutoFlow: 'dense',
    },

    [theme.mediaInverse.md]: {
      gridGap: 20,
      gridTemplateColumns: 'repeat(2,1fr)',
      paddingLeft: theme.paddingMobile[1],
      paddingRight: theme.paddingMobile[1],
    },

    [theme.mediaInverse.sm]: {
      paddingTop: 30,
      paddingBottom: 60,
      paddingLeft: theme.paddingMobile[1],
      paddingRight: theme.paddingMobile[1],
      gridTemplateColumns: 'repeat(1,1fr)',
      gridGap: 0,
    },
  },
})
